module.exports = "<wor-icon icon=\"{{ getIcon() }}\"></wor-icon>\n";